import { Component, OnInit } from '@angular/core';
import { IdP } from '../models/idp';
import { Alert } from '../shared/alert';
import { AppTitle } from '../shared/title';
import { ActivatedRoute, Router } from '@angular/router';
import { IdentityService } from '../services/identity.service';
import { Subscription } from 'rxjs';
import { EndpointsReply } from '../models/test_urls_reply';

@Component({
  selector: 'app-idp-config',
  template: `
    <div class="row" [hidden]="msgHead.msg == ''">
      <div class="col-lg-8 col-md-6 col-xs-12">
          <alert [alert]="msgHead"></alert>
      </div>
    </div>
    <div *ngIf="hasAccess" class="row">
      <div class="col-lg-6 col-md-6 col-xs-12">
          <alert [alert]="msg" style="display:block;"></alert>
      </div>
    </div>
    <div class="col-lg-8 col-md-12 col-xs-12">
        <p style='color: #919191;'>Service Provider Endpoints</p>
            <div class="customHr" style="width:150px">.</div>
            <p>Entity ID: <a href="{{data.entityId}}">{{ data.entityId }}</a></p>
            <p>Metadata URL: <a href="{{data.metadataUrl}}">{{ data.metadataUrl }}</a></p>
            <p style="margin-bottom:20px;">ACS URL: <a href="{{data.acsUrl}}">{{ data.acsUrl }}</a></p>

        <p style='color: #919191;'>Test IdP</p>
            <div class="customHr" style="width:150px">.</div>
            <p style="margin-bottom:10px;">Login URL: <a href="{{data.loginUrl}}">{{ data.loginUrl }}</a></p>

            <small>Note: Use incognito page to test, so that it doesn't use open user session.</small>

        <div style="margin-top:25px;">
            <a style="cursor: pointer;" (click)="goBack()">Go Back</a>
        </div>
    </div>
  `,
})
export class IdPEndpointsComponent implements OnInit {
    data: EndpointsReply;
    msg: Alert;
    msgHead: Alert;
    acctNumber: string;
    hasAccess: boolean;
    idParam: string;
    nameQueryParam: string;
    private subscriptionQueryParams: Subscription;

    constructor(private title: AppTitle, private activatedRoute: ActivatedRoute, private idsvc: IdentityService, private router: Router) {
        this.hasAccess = true;
        this.msg = new Alert();
        this.msgHead = new Alert();
        title.setTitles({
            title: 'Endpoints - Identity Provider',
            dashboard: 'Endpoints - Identity Provider'
        });
        this.subscriptionQueryParams = activatedRoute.queryParams.subscribe(
			(params) => {
				this.nameQueryParam = params['name'];
			}
        );
        this.data = new EndpointsReply();
    }

    ngOnInit() {
        this.idParam = this.activatedRoute.snapshot.params['id'];
        this.acctNumber = this.activatedRoute.snapshot.params['acctNumber'];
        if (this.acctNumber != null) {
            this.idsvc.validateAcctNumber(this.acctNumber)
                .subscribe(res => {
                    if (!res) {
                        this.msgHead.error(`You don't have access to this district number ${this.acctNumber}`);
                        this.hasAccess = false;
                    }
                }, err => {
                    console.log(err);
                    let e = this.idsvc.getUserErrorDefault(err);
                    this.msgHead.error(e);
                    this.hasAccess = false;
                })
        }
        this.title.setBreadcrumbs([
            { title: 'Identity Providers', link: `/idp/${this.acctNumber}/idps` },
            { title: decodeURIComponent(this.nameQueryParam) + ' ', link: `/idp/${this.acctNumber}/idps/${this.idParam}/edit` },
            { title: 'Endpoints', link: `` }
        ]);
        this.loadData();
    }

    loadData() {
        this.idsvc.endpointsApi(this.acctNumber)
        .subscribe((tur: EndpointsReply) => {
            this.data = tur;
        }, err => {
            console.log(err);
            if (this.idsvc.isErrNotFound(err)) {
            this.msg.warning(this.idsvc.getUserError(err));
            } else {
            if (this.idsvc.isErrUnauthorized(err)) {
                this.hasAccess = false;
                this.msg.error(this.idsvc.getUserErrorDefault(err));
            } else {
                this.msg.error(this.idsvc.getUserErrorDefault(err));
            }
            }
        });
    }

    goBack() {
		this.router.navigate([`idp/${this.acctNumber}/idps`]);
		return;
    }
}
